module.exports = __webpack_public_path__ + "static/media/workshop_0005.68016bd5.png";